import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useMemo, useEffect } from "react";
import docotorImg from "../../assets/doctor.jpg";
import { convertToCurrency } from "../../utils/convert-to-currency";
import { useSelector } from "react-redux";
import { getDoctorProfileTotalFee, getServiceTotalFee } from "../../utils/fee";
import { getDoctorsConsultingFeeNotices } from "../../app/apiManager/doctorServices";

const DoctorDetails = ({
  doctor,
  doctorName,
  doctorId,
  qualification,
  regtistrationNo,
  languages,
  email = "",
  isOtherCountry,
  action = () => {},
}) => {
  console.log(doctor);
  const [noImage, setNoImage] = useState(false);
  const [consultingNotice, setConsultingNotice] = useState("");

  useEffect(() => {
    getDoctorsConsultingFeeNotices(
      (response) => {
        console.log("getDoctorsConsultingFeeNotices response:", response);
        if (Array.isArray(response)) {
          const match = response.find((item) => {
            const matchesDoctor = Number(item.DoctorID) === Number(doctorId);
            const responseBranchId = item.BranchId ?? item.BranchId ?? item.BranchId;
            const matchesBranch = Number(responseBranchId) === Number(process.env.REACT_APP_BRANCH_ID);
            return matchesDoctor && matchesBranch;
          });
          if (match) {
            setConsultingNotice(match.Notice);
          } else {
            setConsultingNotice("");
          }
        }
      },
      (error) => {
        console.error("getDoctorsConsultingFeeNotices error:", error);
      }
    );
  }, [doctorId]);

  const selectedService = useSelector((state) => state.placeAppointment.service);
  const serviceTotalFee = getServiceTotalFee(selectedService);
  const doctorProfileTotalFee = getDoctorProfileTotalFee(doctor);
  const totalFee = serviceTotalFee != null ? serviceTotalFee : doctorProfileTotalFee;

  const fee = isOtherCountry
    ? "USD " + process.env.REACT_APP_CHANNELING_FEE_OTHER + ".00"
    : convertToCurrency({
        amount: totalFee ?? 0,
        currency: "Rs.",
      });

  const feeService = isOtherCountry
    ? "USD " + process.env.REACT_APP_SERVICE_FEE_OTHER + ".00"
    : "Rs. " + process.env.REACT_APP_SERVICE_FEE + ".00";

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const image = useMemo(
    () =>
      `${process.env.REACT_APP_VC_DOMAIN}${process.env.REACT_APP_IMAGE_PATH}/${doctorId}.png`,
    [doctorId]
  );

  return (
    <div>
      {/* load image to see whether image is available. loading over network throws cors */}
      <img
        src={image}
        alt=""
        onError={(e) => {
          setNoImage(true);
        }}
        onLoad={(e) => {
          setNoImage(false);
        }}
        style={{
          display: "none",
        }}
      />
      <Box
        sx={{
          p: { xs: 0, sm: 2, lg: 2 },
          mt: { xs: 2, sm: 0, lg: 0 },
        }}
      >
        <Grid container gap={1} mb={2}>
          <Grid
            item
            display="flex"
            sx={{
              backgroundImage: `url(${noImage ? docotorImg : image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              height: {
                xs: "7rem",
              },
              width: {
                xs: "7rem",
              },
            }}
          >
            {/* <img
              src={image}
              alt=""
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = docotorImg;
              }}
              style={{
                height: "100%",
              }}
            /> */}
          </Grid>
          <Grid item xs>
            <Typography fontWeight={"bold"} fontSize="1.2rem">
              {doctorName}
            </Typography>
            <Typography fontSize="0.8rem">
              {qualification}
              {doctor.IsSLMCHide === false ?(
                <>
              <br />
              SLMC REG No :{regtistrationNo}
              </>
              )  :null}
              
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          mb={1}
          mt={4}
          sx={{
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Grid item xs={6}>
            <Typography fontWeight={"bold"}> Consultations In </Typography>
            <Typography style={{ color: "blue" }}> {doctor.languages} </Typography>
          </Grid>
          <Grid 
            item
            xs={6}
            sx={{
              mt: { xs: 2, md: 0 },
            }}
          >
            <Typography fontWeight={"bold"}> Contact via </Typography>
            <Typography
              {...(email.length > 20 && {
                title: email,
              })}
            >
              <a href={`mailto:${email}`} style={{ color: "blue" }}>
                {email.length > 20 && isDesktop
                  ? email.substring(0, 20) + "..."
                  : email.length > 40
                  ? email.substring(0, 40) + "..."
                  : email}
              </a>
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ marginBottom: 2 }} mt={3}>
          <Typography fontWeight={"bold"}> Consultation Fee </Typography>
          <Typography>{fee}/=</Typography>
          {/* <Typography>Service Fee - {feeService}/=</Typography> */}
        </Box>
        {consultingNotice && (
          <Box sx={{ marginBottom: 2 }} mt={3}>
            <Typography>
              {consultingNotice}
            </Typography>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default DoctorDetails;
